import React from "react";
import "./RegisterProfessional.css";

import {
  FaUserTie,
  FaHandshake,
  FaChartLine,
  FaCheckCircle
} from "react-icons/fa";

function RegisterProfessional() {
  return (
    <>

      {/* =====================================
              HERO SECTION
      ===================================== */}

      <section
        className="cc-register-hero"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1920&q=80')",
        }}
      >
        <div className="cc-register-overlay">

          <span>
            JOIN OUR PROFESSIONAL NETWORK
          </span>

          <h1>
            Register as a
            <br />
            Professional
          </h1>

          <p>
            Grow your real estate business with InteriorMart.
            Connect with verified buyers, sellers and property
            owners across India and receive genuine leads every day.
          </p>

          <button>
            Become a Partner
          </button>

        </div>

      </section>



      {/* =====================================
              WHY JOIN
      ===================================== */}

      <section className="cc-register-why">

        <div className="cc-register-heading">

          <h2>Why Join InteriorMart?</h2>

          <p>
            Join thousands of trusted professionals and expand your
            business with premium exposure.
          </p>

        </div>

        <div className="cc-register-why-grid">

          {/* CARD */}

          <div className="cc-register-card">

            <div className="cc-register-icon">
              <FaHandshake />
            </div>

            <h3>Get Genuine Leads</h3>

            <p>
              Receive verified customer enquiries directly
              from interested buyers and sellers.
            </p>

          </div>



          <div className="cc-register-card">

            <div className="cc-register-icon">
              <FaChartLine />
            </div>

            <h3>Grow Your Business</h3>

            <p>
              Increase your visibility and build your
              professional brand online.
            </p>

          </div>



          <div className="cc-register-card">

            <div className="cc-register-icon">
              <FaCheckCircle />
            </div>

            <h3>Verified Badge</h3>

            <p>
              Get a verified profile that builds trust
              among customers instantly.
            </p>

          </div>



          <div className="cc-register-card">

            <div className="cc-register-icon">
              <FaUserTie />
            </div>

            <h3>Professional Dashboard</h3>

            <p>
              Manage leads, profile, projects and customer
              enquiries from one dashboard.
            </p>

          </div>

        </div>

      </section>

            {/* =====================================
              REGISTRATION FORM
      ===================================== */}

      <section className="cc-register-form-section">

        <div className="cc-register-heading">

          <h2>Professional Registration Form</h2>

          <p>
            Complete the details below to become a verified
            InteriorMart Professional.
          </p>

        </div>

        <form className="cc-register-form">

          <div className="cc-register-grid">

            {/* Full Name */}

            <div className="cc-register-input">

              <label>Full Name *</label>

              <input
                type="text"
                placeholder="Enter Full Name"
              />

            </div>

            {/* Company */}

            <div className="cc-register-input">

              <label>Company Name *</label>

              <input
                type="text"
                placeholder="Enter Company Name"
              />

            </div>

            {/* Email */}

            <div className="cc-register-input">

              <label>Email Address *</label>

              <input
                type="email"
                placeholder="Enter Email"
              />

            </div>

            {/* Mobile */}

            <div className="cc-register-input">

              <label>Mobile Number *</label>

              <input
                type="tel"
                placeholder="Enter Mobile Number"
              />

            </div>

            {/* Password */}

            <div className="cc-register-input">

              <label>Password *</label>

              <input
                type="password"
                placeholder="Create Password"
              />

            </div>

            {/* Confirm */}

            <div className="cc-register-input">

              <label>Confirm Password *</label>

              <input
                type="password"
                placeholder="Confirm Password"
              />

            </div>

            {/* Category */}

            <div className="cc-register-input">

              <label>Professional Category *</label>

              <select>

                <option>Select Category</option>

                <option>Real Estate Agent</option>

                <option>Builder</option>

                <option>Property Dealer</option>

                <option>Interior Designer</option>

                <option>Architect</option>

                <option>Civil Engineer</option>

                <option>Legal Consultant</option>

                <option>Home Loan Consultant</option>

              </select>

            </div>

            {/* Experience */}

            <div className="cc-register-input">

              <label>Experience *</label>

              <select>

                <option>Select Experience</option>

                <option>0 - 2 Years</option>

                <option>2 - 5 Years</option>

                <option>5 - 10 Years</option>

                <option>10+ Years</option>

              </select>

            </div>

            {/* Qualification */}

            <div className="cc-register-input">

              <label>Qualification</label>

              <input
                type="text"
                placeholder="Highest Qualification"
              />

            </div>

            {/* Website */}

            <div className="cc-register-input">

              <label>Website</label>

              <input
                type="text"
                placeholder="https://yourwebsite.com"
              />

            </div>

            {/* LinkedIn */}

            <div className="cc-register-input">

              <label>LinkedIn Profile</label>

              <input
                type="text"
                placeholder="LinkedIn URL"
              />

            </div>

            {/* GST */}

            <div className="cc-register-input">

              <label>GST Number</label>

              <input
                type="text"
                placeholder="GST Number"
              />

            </div>

          </div>

                    <div className="cc-register-grid">

            {/* Office Address */}

            <div className="cc-register-input cc-register-full">

              <label>Office Address *</label>

              <textarea
                rows="4"
                placeholder="Enter Complete Office Address"
              ></textarea>

            </div>

            {/* City */}

            <div className="cc-register-input">

              <label>City *</label>

              <input
                type="text"
                placeholder="Enter City"
              />

            </div>

            {/* State */}

            <div className="cc-register-input">

              <label>State *</label>

              <input
                type="text"
                placeholder="Enter State"
              />

            </div>

            {/* Pincode */}

            <div className="cc-register-input">

              <label>Pincode *</label>

              <input
                type="text"
                placeholder="Enter Pincode"
              />

            </div>

            {/* Service Area */}

            <div className="cc-register-input">

              <label>Service Areas *</label>

              <input
                type="text"
                placeholder="Example: Zirakpur, Chandigarh, Mohali"
              />

            </div>

            {/* Working Hours */}

            <div className="cc-register-input">

              <label>Working Hours</label>

              <input
                type="text"
                placeholder="09:00 AM - 07:00 PM"
              />

            </div>

            {/* Charges */}

            <div className="cc-register-input">

              <label>Consultation Charges</label>

              <input
                type="text"
                placeholder="₹500 / Visit"
              />

            </div>

            {/* Languages */}

            <div className="cc-register-input">

              <label>Languages Known</label>

              <input
                type="text"
                placeholder="English, Hindi, Punjabi"
              />

            </div>

            {/* RERA */}

            <div className="cc-register-input">

              <label>RERA Number</label>

              <input
                type="text"
                placeholder="Enter RERA Number"
              />

            </div>

            {/* Aadhaar */}

            <div className="cc-register-input">

              <label>Upload Aadhaar Card</label>

              <input type="file" />

            </div>

            {/* PAN */}

            <div className="cc-register-input">

              <label>Upload PAN Card</label>

              <input type="file" />

            </div>

            {/* Profile */}

            <div className="cc-register-input">

              <label>Profile Photo</label>

              <input type="file" />

            </div>

            {/* Logo */}

            <div className="cc-register-input">

              <label>Company Logo</label>

              <input type="file" />

            </div>

            {/* Service Description */}

            <div className="cc-register-input cc-register-full">

              <label>Service Description *</label>

              <textarea
                rows="6"
                placeholder="Write about your services, experience and specialization..."
              ></textarea>

            </div>

          </div>

          {/* Terms */}

          <div className="cc-register-checkbox">

            <input
              type="checkbox"
              id="agree"
            />

            <label htmlFor="agree">
              I agree to the Terms & Conditions and Privacy Policy.
            </label>

          </div>

          {/* Button */}

          <div className="cc-register-btn">

            <button type="submit">
              Register as a Professional
            </button>

          </div>

        </form>

      </section>

            {/* =====================================
            MEMBERSHIP PLANS
      ===================================== */}

      <section className="cc-register-plan-section">

        <div className="cc-register-heading">

          <h2>Choose Your Membership Plan</h2>

          <p>
            Select the perfect membership plan and start growing
            your business with premium customer leads.
          </p>

        </div>

        <div className="cc-register-plan-grid">

          {/* BASIC */}

          <div className="cc-register-plan-card">

            <h3>Basic</h3>

            <h1>₹999</h1>

            <span>/ Month</span>

            <ul>

              <li>✔ Verified Profile</li>

              <li>✔ 20 Customer Leads</li>

              <li>✔ Email Support</li>

              <li>✔ Dashboard Access</li>

              <li>✔ Business Listing</li>

            </ul>

            <button>
              Choose Plan
            </button>

          </div>



          {/* PREMIUM */}

          <div className="cc-register-plan-card active">

            <div className="cc-register-popular">

              Most Popular

            </div>

            <h3>Premium</h3>

            <h1>₹1999</h1>

            <span>/ Month</span>

            <ul>

              <li>✔ Unlimited Leads</li>

              <li>✔ Verified Badge</li>

              <li>✔ Featured Listing</li>

              <li>✔ WhatsApp Support</li>

              <li>✔ Business Analytics</li>

              <li>✔ Priority Ranking</li>

            </ul>

            <button>

              Choose Plan

            </button>

          </div>



          {/* ENTERPRISE */}

          <div className="cc-register-plan-card">

            <h3>Enterprise</h3>

            <h1>₹4999</h1>

            <span>/ Month</span>

            <ul>

              <li>✔ Everything in Premium</li>

              <li>✔ Dedicated Manager</li>

              <li>✔ Unlimited Visibility</li>

              <li>✔ API Integration</li>

              <li>✔ Premium Support</li>

              <li>✔ Custom Branding</li>

            </ul>

            <button>

              Choose Plan

            </button>

          </div>

        </div>

      </section>



      {/* =====================================
            REGISTRATION PROCESS
      ===================================== */}

      <section className="cc-register-process">

        <div className="cc-register-heading">

          <h2>Simple Registration Process</h2>

          <p>
            Join InteriorMart in just four easy steps.
          </p>

        </div>

        <div className="cc-register-process-grid">

          <div className="cc-register-step">

            <h1>01</h1>

            <h3>Fill Registration Form</h3>

            <p>
              Complete all your professional details accurately.
            </p>

          </div>

          <div className="cc-register-step">

            <h1>02</h1>

            <h3>Upload Documents</h3>

            <p>
              Upload identity proof and business documents.
            </p>

          </div>

          <div className="cc-register-step">

            <h1>03</h1>

            <h3>Verification</h3>

            <p>
              Our team verifies your profile within 24–48 hours.
            </p>

          </div>

          <div className="cc-register-step">

            <h1>04</h1>

            <h3>Start Receiving Leads</h3>

            <p>
              Your profile goes live and customers can contact you.
            </p>

          </div>

        </div>

      </section>

            {/* =====================================
                BENEFITS SECTION
      ===================================== */}

      <section className="cc-register-benefits">

        <div className="cc-register-heading">

          <h2>Benefits of Joining InteriorMart</h2>

          <p>
            Build trust, increase visibility and grow your business
            with India's trusted professional platform.
          </p>

        </div>

        <div className="cc-register-benefit-grid">

          <div className="cc-register-benefit-card">
            <h3>✓ Unlimited Customer Leads</h3>
            <p>
              Connect with genuine customers looking for professional services.
            </p>
          </div>

          <div className="cc-register-benefit-card">
            <h3>✓ Verified Professional Profile</h3>
            <p>
              Increase customer trust with a verified business profile.
            </p>
          </div>

          <div className="cc-register-benefit-card">
            <h3>✓ Business Promotion</h3>
            <p>
              Get featured on the homepage and category listings.
            </p>
          </div>

          <div className="cc-register-benefit-card">
            <h3>✓ Customer Reviews</h3>
            <p>
              Build credibility through genuine client ratings and reviews.
            </p>
          </div>

          <div className="cc-register-benefit-card">
            <h3>✓ Business Dashboard</h3>
            <p>
              Manage enquiries, projects and profile from one place.
            </p>
          </div>

          <div className="cc-register-benefit-card">
            <h3>✓ 24×7 Support</h3>
            <p>
              Dedicated customer support whenever you need assistance.
            </p>
          </div>

        </div>

      </section>



      {/* =====================================
                    FAQ
      ===================================== */}

      <section className="cc-register-faq">

        <div className="cc-register-heading">

          <h2>Frequently Asked Questions</h2>

          <p>
            Find answers to the most common registration questions.
          </p>

        </div>

        <div className="cc-register-faq-box">

          <div className="cc-register-faq-item">
            <h3>How long does verification take?</h3>
            <p>
              Usually within 24–48 working hours after document submission.
            </p>
          </div>

          <div className="cc-register-faq-item">
            <h3>Is registration free?</h3>
            <p>
              Yes. You can create an account for free and upgrade anytime.
            </p>
          </div>

          <div className="cc-register-faq-item">
            <h3>Can I edit my profile later?</h3>
            <p>
              Yes. You can update your business information anytime.
            </p>
          </div>

          <div className="cc-register-faq-item">
            <h3>Which documents are required?</h3>
            <p>
              Aadhaar, PAN, Business Proof and optional RERA certificate.
            </p>
          </div>

        </div>

      </section>



      {/* =====================================
                    CTA
      ===================================== */}

      <section
        className="cc-register-cta"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1920&q=80')",
        }}
      >

        <div className="cc-register-cta-overlay">

          <h2>
            Ready to Grow Your Business?
          </h2>

          <p>
            Become a verified InteriorMart Professional today
            and start receiving quality customer enquiries.
          </p>

          <button>
            Register Today
          </button>

        </div>

      </section>

    </>
  );
}

export default RegisterProfessional;